import type { FC, ReactNode } from 'react'
import type { PhotoId } from '@/components/generals/photo'

import { delay } from '@/lib/motion'
import { Photo } from '@/components/generals/photo'
import { CardFrame } from '@/components/generals/paper'

interface Scouted {
    photo: PhotoId
    name: string
    role: string
    scout: string
}

const SCOUTED: Scouted[] = [
    { photo: 'adrian', name: 'Adrian Keller', role: 'Motion and Interaction Designer', scout: 'Teodor Valk' },
    { photo: 'nora', name: 'Nora Hale', role: 'Staff Product Designer', scout: 'Maren Holt' }
]

/** The hero picture of How it works: two recently scouted designers side by side, each with the scout who spotted them. */
export const Film: FC = (): ReactNode => {
    return (
        <div className='enter relative z-[1] mx-auto mt-[clamp(48px,5vw,72px)] w-[min(100%,1080px)]' style={delay(380)}>
            {/* the cream halo lifts the card off the sky field */}
            <CardFrame className='shadow-[0_0_44px_30px_var(--background)]' windowClassName='grid aspect-video grid-cols-2 gap-1 bg-paper max-sm:aspect-[4/3]'>
                {SCOUTED.map((person, index) => (
                    <figure key={person.name} className='relative overflow-hidden'>
                        <Photo
                            id={person.photo}
                            alt={`Portrait of ${person.name}`}
                            sizes='(min-width: 1080px) 540px, 50vw'
                            priority={index === 0}
                            className='absolute inset-0 size-full'
                        />
                        <figcaption className='absolute inset-x-3 bottom-3 z-10 flex justify-start sm:inset-x-4 sm:bottom-4'>
                            <span className='rounded-[10px] border border-ink/10 bg-paper/90 px-3 py-2 text-left backdrop-blur-[6px] max-sm:px-2.5 max-sm:py-1.5'>
                                <span className='block font-serif text-[16px] leading-tight text-ink max-sm:text-[14px]'>
                                    {person.name}
                                </span>
                                <span className='mt-0.5 block text-[12px] leading-snug text-ink/60 max-sm:hidden'>
                                    {person.role}
                                </span>
                                <span className='mt-1 block text-[12px] leading-snug text-ink/60 max-sm:text-[11px]'>
                                    Scouted by {person.scout}
                                </span>
                            </span>
                        </figcaption>
                    </figure>
                ))}

                <span className='chip-label absolute left-3 top-3 z-30 inline-flex h-7 items-center gap-2 rounded-full border border-ink/15 bg-paper/85 pl-2.5 pr-3 text-ink backdrop-blur-[6px] sm:left-4 sm:top-4'>
                    <span aria-hidden='true' className='size-1.5 rounded-full bg-clay' />
                    Recently scouted
                </span>
            </CardFrame>
        </div>
    )
}
